export const initialDialog = {
  isDialogOpen: false,
  title: '',
  message: [],
  content: null,
  iconType: null,
  buttonLeft: {},
  buttonRight: {},
}
